import { useEffect, useState } from 'react'
import styled from 'styled-components'
import ClosedBids from './Tabs/ClosedBids/ClosedBids'
import Leaderboard from './Tabs/Leaderboard/Leaderboard'
import LiveBids from './Tabs/LiveBids/LiveBids'
import Tabs from './Tabs/Tabs'
import { currencyFormatter } from 'utils'
import { useCustomEventListener } from 'react-custom-events'
import { EVENTS } from 'constants/events.js'
import { usePriceFeed } from 'hooks/usePriceFeed'
// import { LVG_ASSETS } from 'constants/games/lvg/lvgAssets'
import { ASSETS } from 'constants/assets'
import { Ranking } from './Tabs/Ranking'
import { LONG_DASH } from 'constants/index'
// import { RewardsPool } from './Tabs/RewardsPool'
import { ContentSwitcherByState } from 'components/Atoms/ContentSwitcherByState'
import { getPnL } from 'utils/pnl'
import { YourBidsTab } from './Tabs/YourBidsNew/Tab'
import { YourBids } from './Tabs/YourBidsNew/Panel'

const TABS = [
  { id: 0, content: <YourBidsTab /> },
  { id: 1, content: 'LIVE BIDS' },
  { id: 2, content: 'CLOSED BIDS' },
  { id: 3, content: 'TOP BIDS' },
  { id: 4, content: 'LEADERBOARD' },
  // {
  //   id: 5,
  //   content: 'REWARDS POOL',
  //   infoTooltip:
  //     'Pool percentage is decided based on how a bidder performs when compared to other bidders in the pool - based on the total bid amount and net P&L.'
  // }
]

const InfiniteLeaderboard = ({ data = [], leaderboardData, LeaderboardSortBy }) => {
  const [currentTab, setCurrentTab] = useState(TABS[0].id)
  const [tableData, setTableData] = useState({
    nonLive: [],
    live: [],
  })
  const { getPriceFeed } = usePriceFeed()
  const [tableHeaders, setTableHeaders] = useState([])

  useCustomEventListener(EVENTS.LVG_ORDER_PENDING, () => setCurrentTab(TABS[0].id))

  const onTabSelected = (id) => setCurrentTab(id)

  const getAssetId = (symbol) => {
    return ASSETS.find((asset) => asset.id === symbol)?.id
  }
  const getAssetDecimals = (symbol) => {
    return ASSETS.find((asset) => asset.id === symbol)?.fiatDecimals
  }

  const makeLiveBidsData = (data) => {
    const liveData = []

    data.all.live.map((order, index) => {
      if (order.asset === 'XBT/USD') order.asset = 'BTC/USD'

      const {
        bidder,
        status,
        asset,
        entryPrice,
        userFillDollarAmount,
        amount,
        fillQuantity,
        bustPrice,
        side,
        address,
        username,
        avatar,
        createdAt,
        updatedAt,
        takeProfitPrice,
        userStopLossPrice,
        uuid,
        leverage,
        trailingStopPercent,
        trailingStopValue,
      } = order

      const ROI =
        (getPnL(entryPrice, getPriceFeed(asset)?.price, side, fillQuantity, leverage, asset) * 100) /
        Number(userFillDollarAmount)
      
      liveData.push({
        uuid,
        Status: status,
        Bidder: bidder,
        Asset: getAssetId(asset),
        Entry: entryPrice ? Number(entryPrice).toFixed(getAssetDecimals(asset)) : '-',
        'Bid Amount': currencyFormatter(amount),
        Bust: bustPrice ? Number(bustPrice).toFixed(getAssetDecimals(asset)) : '-',
        Multiplier: `x${leverage}`,
        TPSL: (
          <>
            TP: {takeProfitPrice? currencyFormatter(takeProfitPrice, { decimalDigits: getAssetDecimals(asset), useLongNumber: true }) : `${LONG_DASH}`}
            <br />
            SL: {userStopLossPrice ? currencyFormatter(userStopLossPrice, { decimalDigits: getAssetDecimals(asset), useLongNumber: true }): `${LONG_DASH}`}
            <br />
            TS: {trailingStopPercent ? `${currencyFormatter(trailingStopPercent, {noCurrencySign: true})}%`
              : trailingStopValue ? currencyFormatter(trailingStopValue, { decimalDigits: getAssetDecimals(asset), useLongNumber: true }) : `${LONG_DASH}`}
            </>),
        Side: side,
        'P&L': currencyFormatter(getPnL(entryPrice, getPriceFeed(asset)?.price, side, fillQuantity, leverage, asset), {
          decimalDigits: getAssetDecimals(asset),
          useLongNumber: true,
        }),

        ROI: `${Number.isNaN(ROI) ? '0.00' : ROI.toFixed(2)}%`,
        Address: address,
        username,
        avatar,
        createdAt: createdAt,
        updatedAt: updatedAt,
        assetType: ASSETS.find((lvgAsset) => lvgAsset.id === asset)?.type,
      })
    })
    setTableData({ nonLive: [], live: liveData })
    setTableHeaders(['Bidder', 'Asset', 'Entry', 'Bid Amount', 'Bust', 'Multiplier', 'TP/SL/TS', 'P&L', 'ROI'])
  }

  const makeClosedBidsData = (data) => {
    let { closed } = data.all

    // closed = closed.slice(0, 25)

    const closedData = []
    closed.map((order, index) => {
      const {
        bidder,
        status,
        asset,
        entryPrice,
        exitPrice,
        userFillDollarAmount,
        amount,
        bustPrice,
        side,
        address,
        username,
        avatar,
        createdAt,
        updatedAt,
        leverage,
        takeProfitPrice,
        userStopLossPrice,
        trailingStopPercent,
        trailingStopValue,
        pnl,
        uuid,
      } = order

      const ROI = Number((pnl * 100) / Number(userFillDollarAmount))

      closedData.push({
        uuid,
        Status: status,
        Bidder: bidder,
        Asset: getAssetId(asset),
        Entry: entryPrice ? Number(entryPrice).toFixed(getAssetDecimals(asset)) : '-',
        'Bid Amount': currencyFormatter(amount),
        Bust: bustPrice ? Number(bustPrice).toFixed(getAssetDecimals(asset)) : '-',
        Multiplier: `x${leverage}`,
        Side: side,
        Exit: exitPrice ? Number(exitPrice).toFixed(getAssetDecimals(asset)) : '-',
        TPSL: (
          <>
            TP: {takeProfitPrice? currencyFormatter(takeProfitPrice, { decimalDigits: getAssetDecimals(asset), useLongNumber: true }) : `${LONG_DASH}`}
            <br />
            SL: {userStopLossPrice ? currencyFormatter(userStopLossPrice, { decimalDigits: getAssetDecimals(asset), useLongNumber: true }): `${LONG_DASH}`}
            <br />
            TS: {trailingStopPercent ? `${currencyFormatter(trailingStopPercent, {noCurrencySign: true})}%`
              : trailingStopValue ? currencyFormatter(trailingStopValue, { decimalDigits: getAssetDecimals(asset), useLongNumber: true }) : `${LONG_DASH}`}
            </>),
        'P&L': currencyFormatter(pnl, {
          decimalDigits: getAssetDecimals(asset),
          useLongNumber: true,
        }),
        ROI: `${Number.isNaN(ROI) ? '0.00' : ROI.toFixed(2)}%`,
        Result: '',
        Address: address,
        username,
        avatar,
        createdAt: createdAt,
        updatedAt: updatedAt,
        assetType: ASSETS.filter((lvgAsset) => lvgAsset.id === asset)[0]?.type,
      })
    })
    setTableData({ nonLive: closedData, live: [] })
    setTableHeaders([
      'Bidder',
      'Asset',
      'Entry',
      'Bid Amount',
      'Bust',
      'Multiplier',
      'Exit',
      'TP/SL/TS',
      'P&L',
      'ROI',
      'Result',
    ])
  }

  const makeLeaderboardData = (data) => {
    const leaderboardData = []

    data.map((row, index) => {
      const {
        status,
        asset,
        entryPrice,
        exitPrice,
        userFillDollarAmount,
        amount,
        bustPrice,
        pnl,
        side,
        address,
        username,
        avatar,
        createdAt,
        updatedAt,
        leverage,
        userOrderId,
      } = row

      const ROI = Number((pnl * 100) / Number(userFillDollarAmount))

      leaderboardData.push({
        userOrderId: userOrderId,
        Status: status,
        Bidder: '',
        Asset: getAssetId(asset),
        Entry: entryPrice ? Number(entryPrice).toFixed(getAssetDecimals(asset)) : '-',
        'Bid Amount': currencyFormatter(amount),
        Bust: bustPrice ? Number(bustPrice).toFixed(getAssetDecimals(asset)) : '-',
        Multiplier: `x${leverage}`,
        Side: side,
        Exit: exitPrice ? Number(exitPrice).toFixed(getAssetDecimals(asset)) : '-',
        'P&L': currencyFormatter(pnl, {
          decimalDigits: getAssetDecimals(asset),
          useLongNumber: true,
        }),
        ROI: `${Number.isNaN(ROI) ? '0.00' : ROI.toFixed(2)}%`,
        Address: address,
        username,
        avatar,
        createdAt: createdAt,
        updatedAt: updatedAt,
        assetType: ASSETS.find((lvgAsset) => lvgAsset.id === asset)?.type,
      })
    })
    setTableData({ nonLive: leaderboardData, live: [] })
    setTableHeaders(['Bidder', 'Asset', 'Entry', 'Bid Amount', 'Bust', 'Multiplier', 'Exit', 'P&L', 'ROI'])
  }

  const bPrice = getPriceFeed('BTC/USD')?.price

  useEffect(() => {
    const makeTableData = (currentTab) => {
      switch (currentTab) {
        case 1:
          makeLiveBidsData(data)
          break
        case 2:
          makeClosedBidsData(data)
          break
        case 3:
          makeLeaderboardData(leaderboardData)
          break
        default:
          break
      }
    }

    makeTableData(currentTab)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTab, data, bPrice])

  return (
    <StatsTabWrapper>
      <Tabs currentTab={currentTab} onTabSelected={onTabSelected} tabs={TABS} />
      <PanelsContainer>
        <ContentSwitcherByState
          noWrapper
          activeState={currentTab}
          stateObject={{
            [TABS[0].id]: <YourBids />,
            [TABS[1].id]: <LiveBids data={tableData} headers={tableHeaders} />,
            [TABS[2].id]: <ClosedBids data={tableData} headers={tableHeaders} />,
            [TABS[3].id]: <Leaderboard data={tableData} headers={tableHeaders} LeaderboardSortBy={LeaderboardSortBy} />,
            [TABS[4].id]: <Ranking />,
            // [TABS[5].id]: <RewardsPool />
          }}
        />
      </PanelsContainer>
    </StatsTabWrapper>
  )
}

export default InfiniteLeaderboard

const StatsTabWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  position: relative;
  z-index: 0;
  background: var(--bidding-table-background);
  padding: 20px 0 0 0;
  border-radius: 10px 10px 0 0;
  height: 100%;
`

const PanelsContainer = styled.div`
  width: 100%;
  overflow: hidden;
`
